module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$l('download/title')))]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option",
    on: {
      "click": _vm.xmlClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('download/popOver/XML')))]), _vm._v(" "), _c('div', {
    staticClass: "option",
    on: {
      "click": _vm.xmlWeeklyClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('download/popOver/XMLWeekly')))]), _vm._v(" "), _c('div', {
    staticClass: "option",
    on: {
      "click": _vm.rawClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('download/popOver/Raw')))]), _vm._v(" "), _c('div', {
    staticClass: "option",
    on: {
      "click": _vm.globalClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('download/popOver/Global')))]), _vm._v(" "), _c('div', {
    staticClass: "option",
    on: {
      "click": _vm.weathClicked
    }
  }, [_vm._v(_vm._s(_vm.$l('download/popOver/weather')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e42075c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/DownloadPopover.vue
// module id = 466
// module chunks = 1